import { useFitnessTrackerContext } from './Context/FitnessTrackerContext'
import ExpandedDashboard from './ExpandedDashboard'
import CompactDashboard from './CompactDashboard'

export default function FitnessTrackerDashboard() {
  const { expanded } = useFitnessTrackerContext()

  return expanded ? <ExpandedDashboard /> : <CompactDashboard />
}
